const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Name",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "Mobile Number",
    dataIndex: "mobile_no",
    render: defaultRender,
  },
  {
    title: "Domain Name",
    dataIndex: "domainName",
    render: defaultRender,
  },
  {
    title: "License Name",
    dataIndex: "licenseName",
    render: defaultRender,
  },
  {
    title: "Business Logo",
    dataIndex: "businessLogo",
    render: defaultRender,
  },
  {
    title: "URL",
    dataIndex: "url",
    render: defaultRender,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: defaultRender,
  },
   {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
    fixed: 'right',
  },
];

export default columns;
